<template>
  <gkModal
    class="sign"
    gkmodal-color="com"
    :value="visible"
    v-model="visible"
    :maskClickClose="maskClickClose"
    transition="gk-fade-up"
    :needClose="closeable"
    loading
    @close="close"
  >
    <div :class="$style.title">
      <slot name="title" />
    </div>

    <h3 :class="$style.desc">
      <slot name="desc" />
    </h3>

    <slot name="btn">
      <div :class="$style.btn" @click="handleConfirm">
        <slot name="btn-confirm" />
      </div>
    </slot>

    <div slot="footer"></div>
  </gkModal>
</template>

<script>
import gkModal from 'gkSrc/v2/modal'
import VueTypes from 'vue-types'

// import { mapState } from 'vuex'

export default {
  data () {
    return {
      visible: false
    }
  },
  props: {
    closeable: VueTypes.bool.def(true),
    maskClickClose: VueTypes.bool.def(true)
  },
  computed: {
    // ...mapState([
    //   'isMobile'
    // ])
  },
  components: {
    gkModal
  },
  methods: {
    /**
     * public
     * 显示设置弹框
     */
    show (data = {}) {
      this.visible = true
    },
    /**
     * public
     * 关闭设置弹框
     */
    close (emitType) {
      this.visible = false
    },
    /**
     * 确定
     */
    handleConfirm () {
      this.close()

      this.$emit('confirm')
    },
    handleClose () {
      this.close()

      this.$emit('close')
    }
  },
  created () {},
  mounted () {}
}
</script>

<style lang="scss" module>
@import '../../style/bulma/app.sass';
@import '~@geekbang/geek.ui/src/v2/modal/base';

@include appendGkModalColor('com') {
  & [gk-modal-main] {
    box-sizing: border-box;
    width: 494px;
    padding: 26px 30px 30px;
    border-radius: 8px;
    @include mobile {
      width: 72.2vw;
      padding: 20px 0 22px;
      transform: translate3d(0, calc(-50% - 71px), 0) !important;
      border-radius: 5px;
    }
  }

  & [gk-modal-close] {
    top: 17px; right: 22px;
    @include mobile {
       top: 2px; right: 2px;
    }
    &::before, &::after {
      width: 20px; background: #cfcfcf;
      @include mobile {
        width: 14px;
      }
    }
  }
}

.title {
  margin-bottom: 8px;
  font-size: 16px; font-weight: 700;
  line-height: 1;

  @include mobile {
    font-size: 16px;
    text-align: center;
  }
}

.desc {
  margin: 20px 30px 16px;
  font-size: 16px;
  color: $color-text-dark;
  text-align: center;
  line-height: 32px;
  @include mobile {
    margin: 8px 30px 16px;
    color: $color-gray;
    line-height: 20px;
  }
  & .strong {
    color: $primary3;
  }
}

.btn {
  display: flex; justify-content: center;
  width: 230px;
  height: 40px;
  margin: 0 auto;
  background: $primary3;
  border-radius: 4px;
  font-weight: 500;
  color: $color-orange2;
  text-align: center;
  line-height: 40px;
  cursor: pointer;

  @include mobile {
    border-radius: 20px;
  }
}

</style>
